import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import {
  CreateIntakeTransferPayload,
  IntakeTransferRequest,
  IntakeTransferStatus,
  TransferBatchOption,
} from '../types/intakeTransfer';

export const listIntakeTransfers = async (params: {
  page: number;
  pageSize: number;
  status?: IntakeTransferStatus;
  studentId?: number;
}): Promise<PaginatedResponse<IntakeTransferRequest>> => {
  const { data } = await apiClient.get('/intake-transfers', { params });
  return data;
};

export const listTransferBatchOptions = async (): Promise<TransferBatchOption[]> => {
  const { data } = await apiClient.get('/intake-transfers/batch-options');
  return data.data;
};

export const createIntakeTransfer = async (
  payload: CreateIntakeTransferPayload,
): Promise<IntakeTransferRequest> => {
  const { data } = await apiClient.post('/intake-transfers', payload);
  return data.data;
};

export const approveIntakeTransfer = async (
  id: number,
  note?: string,
): Promise<IntakeTransferRequest> => {
  const { data } = await apiClient.post(`/intake-transfers/${id}/approve`, {
    note: note || undefined,
  });
  return data.data;
};

export const rejectIntakeTransfer = async (
  id: number,
  reason: string,
): Promise<IntakeTransferRequest> => {
  const { data } = await apiClient.post(`/intake-transfers/${id}/reject`, { reason });
  return data.data;
};
